import React from 'react';
import styled from '@emotion/styled';

const ListItem = styled.li`
  color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;
`;

const Icon = styled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 44px;
  height: 44px;

  circle {
    fill: #fff;
  }

  path {
    fill: #d9427d;
  }
`;

const Detail = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const TeamTitle = styled.span`
  font-size: 12px;
  display: block;
  padding-bottom: 5px;
`;

const TeamName = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
`;

interface Props {
  teamName: string;
}

const validate = (teamName: string) => {
  return teamName && teamName !== '';
};

{
  /* Internationalise here */
}
const TeamDetail = (props: Props) => {
  const { teamName } = props;
  return (
    <ListItem>
      <Icon data-testid="team-detail-team-icon" viewBox="0 0 44 44">
        <circle cx="22" cy="22" r="22" />
        <path d="M35.64 24c-.23-.85-2.36-1.41-3.5-1.84a1.34 1.34 0 0 1-.31-.31 1.5 1.5 0 0 1-.11-.23 2.65 2.65 0 0 1-.08-.65 1.9 1.9 0 0 0 .45-.52 5.13 5.13 0 0 0 .57-1 .42.42 0 0 0 .28-.21 2.28 2.28 0 0 0 .29-1.34.27.27 0 0 0-.27-.15 3.9 3.9 0 0 0-.08-1 2.49 2.49 0 0 0-4.92.07 3.87 3.87 0 0 0-.07.9.29.29 0 0 0-.3.15 2.28 2.28 0 0 0 .29 1.33.41.41 0 0 0 .31.21 4.86 4.86 0 0 0 .56 1 1.77 1.77 0 0 0 .5.55 1.65 1.65 0 0 1-.17.77l-.09.07-.45.34a12.87 12.87 0 0 0-2.47 1l.63.22a9 9 0 0 1 4.38 3.52H35a.83.83 0 0 0 .82-.82 11.21 11.21 0 0 0-.18-2.06zm-10.19-.63a2 2 0 0 1-.47-.47 2.3 2.3 0 0 1-.17-.36 4 4 0 0 1-.12-1 2.89 2.89 0 0 0 .69-.79 7.79 7.79 0 0 0 .87-1.52.64.64 0 0 0 .43-.32 3.47 3.47 0 0 0 .45-2 .41.41 0 0 0-.42-.23 5.92 5.92 0 0 0-.12-1.48 3.78 3.78 0 0 0-7.48.16A3.93 3.93 0 0 0 19 16a4.15 4.15 0 0 1 0-.46 5.8 5.8 0 0 0 0 1.1.42.42 0 0 0-.43.23 3.46 3.46 0 0 0 .45 2 .62.62 0 0 0 .47.31 7.41 7.41 0 0 0 .86 1.51 2.68 2.68 0 0 0 .77.83 2.51 2.51 0 0 1-.26 1.17l-.14.11-.68.52c-1.45.45-4.65 2.51-5.08 3.85a5.73 5.73 0 0 0-.29 1.56A1.26 1.26 0 0 0 15.86 30h14a1.26 1.26 0 0 0 1.24-1.24 6 6 0 0 0-.3-1.56c-.37-1.29-3.61-3.2-5.35-3.87zm-6-.24c-.77-.39-1.82-.7-2.52-1a1.35 1.35 0 0 1-.31-.31 1.51 1.51 0 0 1-.11-.23 2.66 2.66 0 0 1-.08-.65 1.9 1.9 0 0 0 .45-.52 5.12 5.12 0 0 0 .57-1 .42.42 0 0 0 .28-.21 2.28 2.28 0 0 0 .27-1.34.27.27 0 0 0-.27-.15 3.89 3.89 0 0 0-.08-1 2.49 2.49 0 0 0-4.92.07 3.87 3.87 0 0 0-.07.9.29.29 0 0 0-.3.15 2.27 2.27 0 0 0 .29 1.33.4.4 0 0 0 .31.21 4.86 4.86 0 0 0 .56 1 1.77 1.77 0 0 0 .5.55 1.65 1.65 0 0 1-.17.77l-.09.07-.45.34c-1 .3-3.06 1-3.34 1.83a10.39 10.39 0 0 0-.19 2.08.83.83 0 0 0 .82.82h4a9.23 9.23 0 0 1 4.87-3.75z" />
      </Icon>
      <Detail>
        {validate(teamName) && (
          <>
            <TeamTitle>Team</TeamTitle>
            <TeamName>{teamName}</TeamName>
          </>
        )}
      </Detail>
    </ListItem>
  );
};

export { TeamDetail, TeamDetail as default };
